import { useContext, useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { cloneCampaign, getCampaigns, getObjects, updateCampaign } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link, useNavigate } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";
import slugify from "slugify";
import { updatePage } from "@/api/pages";
import { AppContext } from "@/AppContext";

export const OrderForms = ({ name = "" }) => {
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  // get the list of products from the server
  const loadProducts = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "product" });
    // const response = await getCampaigns({ token, type: "product" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((product: any) => {
          return {
            id: product.id,
            label: product.name,
            caption: `Last Updated: ${moment(product.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src="https://sandcastleassets.s3.us-east-1.amazonaws.com/fs-logo.webp"
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setProductList(seqs);
    }
    setIsLoading(false);
  };

  // Creates a new collection based on the collection funnel template
  const handleCreateForm = async () => {
    const name = prompt("Enter a name for your order form");
    const slug = slugify(String(name));
    const campaignId = "cjyt9x3v0001g0792aync7yje"; // The ID of the collection campaign template (blank)
    if (name) {
      setIsLoading(true);
      const token = getSessionToken();
      const response = await cloneCampaign(campaignId, { token, name });
      const newCampaignId = response?.data?.cloneCampaign?.response?.id;

      // update the type of the campaign to be a content campaign
      const updateResponse = await updateCampaign(newCampaignId, {
        token,
        settings: {
          type: "product",
        },
      });

      // update the slug
      const { data } = await getObjects(newCampaignId);
      const { page } = data?.objects?.[0];
      const pageId = page?.id;
      const slugUpdateResponse = await updatePage(pageId, { token, settings: { slug } });

      console.log(
        "newCampaignId",
        newCampaignId,
        updateResponse,
        slugUpdateResponse
      );

      if (newCampaignId) {
        // navigate to the new funnel
        navigate(`/order-forms/${newCampaignId}`);
      }
    }
  };

  // load the productList when the page loads
  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Button
            label="+ Create an Order Form"
            type={ButtonTypes.OUTLINED}
            onClick={handleCreateForm}
          />
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(productList.length) && (
          <EmptyState
            title="No Forms Yet"
            description="Get started by creating a new form."
            showImage={false}
          >
            <Button
              label="+ Create an Order Form"
              type={ButtonTypes.OUTLINED}
              onClick={handleCreateForm}
            />
          </EmptyState>
        )}
        {!isLoading && Boolean(productList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {productList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/order-forms/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
